export const CONFIDENCE_SCORE_THRESHOLD = 0.95
